@if (componentData$ | async; as data) {
  <div class="">
    <div class="col-md-8 color-knbr-footer p-3 float-left">
      <div class="container-fluid">
        <div class="knbr-footerTop">
          <div class="row">
            @if (node$ | async; as node) {
              <div class="footer-left flex-wrap col-xs-12 col-sm-12 col-md-12 footer-p-5 footer-nav">
                @for (child of node?.children; track $index) {
                  <ng-container *ngTemplateOutlet="nav; context: { node: child, depth: 0 }"></ng-container>
                }
              </div>
            }
            <div class="col-md-4 color-knbr-footer p-3 float-left">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #nav let-node="node" let-depth="depth">
    <div class="footer-colums">
      <ul class="list-unstyled m-0 p-0">
        @if (node.url && (!node.children || node.children?.length === 0)) {
          <cx-generic-link
            [url]="getUrl(node)"
            [target]="node.target"
            [class]="'w-100 p-1 float-left color-white font-size-14 hover-link'">
            {{ node.title }}
          </cx-generic-link>
        }

        @if (node?.children?.length > 0) {
          @for (innerNode of node?.children; track $index) {
            <li class="w-100">
              @if (innerNode.url) {
                <cx-generic-link
                  [url]="innerNode.url"
                  [target]="innerNode.target"
                  [class]="'w-100 p-1 float-left color-white font-size-14 hover-link'">
                  {{ innerNode.title }}
                </cx-generic-link>
              }
            </li>
          }
        }
      </ul>
    </div>
  </ng-template>
}
